import * as React from 'react';
import { ReactElement } from 'react';
import cn from 'classnames';

import '@mos-utils/css/lib/typography/List.css';
import ListItem, { Props as ListItemProps } from './inner/ListItem';

export default function List({
  className,
  ordered = false,
  children,
  ...props
}: Props) {
  return React.createElement(
    ordered ? 'ol' : 'ul',
    {
      className: cn('mos-list', className),
      ...props
    },
    children
  );
}

List['Item'] = ListItem;

interface Props {
  ordered?: boolean;
  children?: ReactElement<ListItemProps, 'li'>;
  className?: string;
}

List.defaultProps = {
  className: '',
  ordered: false,
  children: []
};
